import React from 'react';
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore - types provided via ambient declaration
import { Worker, Viewer, SpecialZoomLevel } from '@react-pdf-viewer/core';
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore - types provided via ambient declaration
import { defaultLayoutPlugin } from '@react-pdf-viewer/default-layout';

// Import styles required by @react-pdf-viewer
import '@react-pdf-viewer/core/lib/styles/index.css';
import '@react-pdf-viewer/default-layout/lib/styles/index.css';

interface PdfPreviewerProps {
    fileUrl: string;
}

// Use a locally bundled worker from pdfjs-dist. Vite will rewrite this URL.
const pdfWorkerUrl: string = new URL('pdfjs-dist/build/pdf.worker.min.js', import.meta.url).toString();

const PdfPreviewer: React.FC<PdfPreviewerProps> = ({ fileUrl }) => {
    const defaultLayout = defaultLayoutPlugin({
        toolbarPlugin: {
            fullScreenPlugin: {
                enableShortcuts: true,
            },
        },
    });

    return (
        <div className="w-full h-full bg-white">
            <Worker workerUrl={pdfWorkerUrl}>
                <Viewer
                    fileUrl={fileUrl}
                    plugins={[defaultLayout]}
                    defaultScale={SpecialZoomLevel.PageWidth}
                />
            </Worker>
        </div>
    );
};

export default PdfPreviewer;


